import React from 'react';

// Red band over each FOH half-hour whose realised mean skill falls below the floor target.
// Positions each breach window by clock time over the same timeSlots axis the day grid uses.
export function SkillFloorDayStrip({ breaches, timeSlots, parseTime, target }) {
  if (!breaches || !breaches.length || !timeSlots || timeSlots.length < 2) return null;
  const min = timeSlots[0];
  const span = timeSlots[timeSlots.length - 1] - timeSlots[0];
  if (span <= 0) return null;

  return (
    <div className="schedule-row" style={{ minHeight: 20 }}>
      <div className="row-label" title={`FOH half-hours whose mean skill is below ${target}`}>
        skill floor breach
      </div>
      <div
        className="shifts-container"
        style={{ position: 'relative', height: 14, background: 'rgba(148,163,184,0.10)', borderRadius: 3 }}
      >
        {breaches.map((b, i) => {
          const left = ((parseTime(b.start) - min) / span) * 100;
          const width = ((parseTime(b.end) - parseTime(b.start)) / span) * 100;
          return (
            <div
              key={i}
              title={`${b.start}–${b.end} · FOH mean skill ${b.meanSkill} (target ${target})`}
              style={{
                position: 'absolute',
                left: `${left}%`,
                width: `${width}%`,
                top: 0,
                height: '100%',
                background: '#e5484d',
                opacity: 0.8,
                borderRadius: 2,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
